module.exports = __webpack_public_path__ + "img/sierra-leone.86820cbb.svg";